import { useState } from 'react'

import {
	EuiButton,
	EuiButtonEmpty,
	EuiFlexGroup,
	EuiFlexItem,
	EuiPopoverFooter,
} from '@equipmentshare/ds2'

import { heapEvent } from '@equipmentshare/heaper'
import useDefaultStoreIds from 'hooks/userPreferences/useDefaultStoreIds'
import useStoreIds from 'hooks/useStoreIds'

export type FooterProps = {
  closePopover: () => void,
}

export default function InventoryLocationsFooter( { closePopover }: FooterProps ) {
	const [ isSaving, setIsSaving ] = useState( false )
	const { inventoryLocationIds, setInventoryLocationIds } = useStoreIds()
	const { defaultStoreIds, save: saveDefaultStoreIds } = useDefaultStoreIds()

	const applyDefault = () => {
		heapEvent( 'Inventory - Stores Dropdown - Click - Apply Default Filter', {} )
		if ( defaultStoreIds ) {
			setInventoryLocationIds( defaultStoreIds.map( ( id ) => id.toString() ) )
			closePopover()
		}
	}

	const saveDefaultStores = async() => {
		setIsSaving( true )
		heapEvent( 'Inventory - Stores Dropdown - Click - Save as Default', {} )
		try {
			await saveDefaultStoreIds( inventoryLocationIds )
		} catch ( e: unknown ) {
			setIsSaving( false )
		}
		closePopover()
	}

	return (
		<EuiPopoverFooter paddingSize="s">
			<EuiFlexGroup justifyContent="spaceBetween">
				<EuiFlexItem grow={false}>
					<EuiButtonEmpty
						color="primary"
						onClick={applyDefault}
						isDisabled={!defaultStoreIds}
						id="applyDefaultBtn"
					>
            Apply default
					</EuiButtonEmpty>
				</EuiFlexItem>
				<EuiFlexItem grow={false}>
					<EuiButton
						color="text"
						onClick={saveDefaultStores}
						isLoading={isSaving}
						id="saveDefaultBtn"
					>
            Save as default
					</EuiButton>
				</EuiFlexItem>
			</EuiFlexGroup>

		</EuiPopoverFooter>
	)
}
